import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// ASSET LOADING CURRENTLY FROM IMPORT WHICH TO USE IMPORT OR PUBLIC DIRECTORY
import SingleImg05 from "./../assets/AyurvedaAssets/images/single-img-05.png";

import TeamListing from "./Components/TeamListing";

export default function Team() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: true, // whether animation should happen only once
    });
  }, []);
  return (
    <div className="site-main">
      {/* Page Title */}
      <div className="prt-page-title-row custom-team-background">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="page-title-heading">
                    <h2 className="title">Meet our Bharat Dhara Privar</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <a title="Homepage" href="index-2.html">
                        Home
                      </a>
                    </span>
                    <span>Team</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <TeamListing />

      {/* cta-section */}
      <section className="prt-row padding_zero-section cta-section03 animation clearfix">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="cta-content text-center">
                <div className="section-title title-style-center_text">
                  <div className="title-header">
                    <h2 className="cta-title">Need a help</h2>
                    <h3 className="cta-titlepre">
                      Are you facing any problem in your health?
                    </h3>
                  </div>
                  <div className="cta-bnt mt-40 fadeup-amin">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-darkcolor"
                      href="contact-us.html"
                    >
                      Contact us now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div
                className="prt_single_image-wrapper cta-img mt-40 res-991-mt-20"
                data-cursor-tooltip=""
              >
                <div className="prt_single_image-wrapper">
                  <a href="team-details.html">
                    <img
                      width="1920"
                      height="400"
                      className="img-fluid"
                      src={SingleImg05}
                      alt="image"
                    />
                  </a>
                </div>
                <div className="prt-pfbox-overlay">
                  <div className="ctaimg-title">
                    <a href="team-details.html">Meet our Bharat Dhara Privar</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* cta-section end */}

      {/* info-section */}
      <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-md-12">
              <div className="prt-info-main-block">
                <div className="info_btn mr-30 res-767-mb-15">
                  <a
                    className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                    href="#"
                  >
                    COVID-19 resources
                  </a>
                </div>

                {/* featured-icon-box */}
                <div className="featured-icon-box icon-align-before-content style2">
                  <div className="featured-icon">
                    <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                      <i className="flaticon-alert"></i>
                    </div>
                  </div>
                  <div className="featured-content">
                    <div className="featured-title">
                      <h3>Get The Health package</h3>
                    </div>
                    <div className="featured-desc">
                      <p>
                        What you need to know about the 2019 - 2023 fly season.
                      </p>
                    </div>
                  </div>
                </div>
                {/* featured-icon-box end */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* info-section end */}
    </div>
  );
}
